<div
    class="badge"
    fxLayout="row"
    fxLayoutAlign="start center"
    [dialogLink]="['notes', ticket.stationId, ticket.ticketId]"
>
    <!-- ticket icon -->
    <mat-icon [svgIcon]="'c-report'"></mat-icon>

    <!-- ticket info -->
    <div fxFlex class="info" fxLayout="column">
        <label>{{ ticket.title | ceCustomerPrivacy: 'station' }}</label>
        <div class="description">
            [{{ ticket.ref | ceCustomerPrivacy: 'randomNumber' }}]
            {{ ticket.description | ceCustomerPrivacy: 'person' }}
        </div>
    </div>
</div>
